var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntermediate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0811 11.2906C22.0811 17.25 17.25 22.0811 11.2906 22.0811C5.3311 22.0811 0.5 17.25 0.5 11.2906C0.5 5.3311 5.3311 0.5 11.2906 0.5C17.25 0.5 22.0811 5.3311 22.0811 11.2906Z",
    stroke: "#FFFFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0183 19.2226C15.2907 19.2226 18.7543 15.6542 18.7543 11.2522C18.7543 6.85023 15.2907 3.28174 11.0183 3.28174C6.74576 3.28174 3.28223 6.85023 3.28223 11.2522C3.28223 15.6542 6.74576 19.2226 11.0183 19.2226Z",
    fill: "#FFFFEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediate);
export default __webpack_public_path__ + "static/media/Intermediate.76e784b0dc0ec3a13c6879fddef45124.svg";
export { ForwardRef as ReactComponent };